var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.item.body),function(child){return _c('sb-render',{key:child.uuid,attrs:{"item":child}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }